import Vue from 'vue'
import Vuex from 'vuex'
import map from './modules/map'
import user from './modules/user'
import scene from './modules/scene'
import service from './modules/service'
import entity from './modules/entity'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    map,
    user,
    scene,
    service,
    entity,
  },
  strict: debug,
})



// WEBPACK FOOTER //
// ./src/store/index.js